<template>
    <div>
        <div class="clearfix mt10 mb10">
            <div class="fl">
                <el-checkbox class="ml15" v-model="selected" @change="changeSelected">来源</el-checkbox>
            </div>
            <div class="fr">
                <div class="search-container primary">
                    <div class="form-box">
                        <input class="input-field" v-model="no" placeholder="请购单号"/>
                        <button class="search-btn" @click="getRequireVoucherList()"><i class="icon iconfont icon-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="column-layout">
            <div class="table-layout">
                <el-table ref="multipleTable" :height="500+'px'" :data="requireVoucherList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                    <el-table-column width="55" v-if="showSelect">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : deviceRequireVoucher!= null && deviceRequireVoucher.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="no" label="请购单号">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click.stop="toDeviceRequireVoucher(rows.row.no)">{{rows.row.no}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="requireComName" align="center" label="申请机构"></el-table-column>
                    <el-table-column prop="applyTime" align="center" label="申请时间"></el-table-column>
                    <el-table-column prop="applicantName" align="center" label="经办人"></el-table-column>
                    <el-table-column prop="desc" label="采购需求"></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import devcReqrApi from '../../api/devcReqr'
    import SwbDeviceRequireVoucherManager from '../retailer/DeviceRequireVoucherManager';

    Routes.add(SwbDeviceRequireVoucherManager);

    export default {
        name: 'swb-device-require-voucher-for-select',
        desc: '设备请求单-选择',
        props: {
            srcId: {},
            toDeviceRequireVoucherList: {
                type: Function
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                requireVoucherList: [],
                no: null,
                deviceRequireVoucher: {
                    id: null
                },
                deviceRequireFlag: {},
                showSelect: false,
                selected: false
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            if(self.srcId != null && self.srcId != '') {
                self.deviceRequireVoucher.id = self.srcId;
                self.selected = true;
            }

            self.deviceRequireFlag = getEnumInfoWith('bizSrcFlag', 'name', 'DeviceRequire');

            //
            self.getRequireVoucherList();
        },
        methods: {
            changeSelected() {
                this.getRequireVoucherList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getRequireVoucherList();
            },
            getRequireVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                postData.filterItems = {};
                let filterItems = {};
                if(!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                filterItems.voucerStatus = getEnumInfoWith('requireVoucherState', 'name', 'AuditPass').value;

                if(self.srcId != null && self.srcId != '' && self.selected) {
                    filterItems.id = self.srcId;
                } else if(self.selected) {
                    self.requireVoucherList = [];
                    return false;
                }
                postData.filterItems = filterItems;
                devcReqrApi.getDeviceRequireVoucherList(postData, function (result) {
                    if(result.type === "info") {
                        self.requireVoucherList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        if(self.selected) {
                            self.showSelect = false;
                        } else {
                            self.showSelect = true;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.deviceRequireVoucher = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let deviceRequireVoucher = self.deviceRequireVoucher;
                if(deviceRequireVoucher.id != null) {
                    let returnInfo = {};
                    returnInfo.srcId = deviceRequireVoucher.id;
                    returnInfo.srcFlag = self.deviceRequireFlag.value;
                    result.type = "info";
                    result.data = returnInfo;
                } else {
                    result.type = "warn";
                    result.message = "请选择对应的来源";
                }
                return result;
            },
            toDeviceRequireVoucher: function (no) {
                this.toDeviceRequireVoucherList.call(parent, no);
            },
//            toDeviceRequireVoucherList: function (no) {
//                let data = {no: no};
//                let hashUrl = Utils.makeUrl(SwbDeviceRequireVoucherManager.path, data);
//                appConf.openPageRouteUrl(null, "/bench/home", hashUrl);
//            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/DeviceRequireVoucherForSelect.vue